import React from "react";
import Hoc from "../../components/HOC";
import AdminDashboard from "./AdminDashboard";
import MarketingExecutiveDashboard from "./MarketingExecutiveDashboard";
import RecruiterDashboard from "./RecruiterDashboard";
import { getValuesFromLocalstorage } from "../../components/Helpers";

const Dashboard = () => {
  const userDetails = getValuesFromLocalstorage("userDetails");
  
  // Route users based on their account type
  if (userDetails?.acctType === "ADMIN") {
    return <AdminDashboard />;
  } else if (userDetails?.acctType === "MKTG_EXEC") {
    return <MarketingExecutiveDashboard />;
  } else if (userDetails?.acctType === "RECRUITER") {
    return <RecruiterDashboard />;
  } else {
    // Fallback for any other user types (shouldn't happen with current setup)
    return <div className="p-5 text-center">Invalid user type. Please contact administrator.</div>;
  }
};

export default Hoc(Dashboard);
